import { useNavigate, useOutlet } from 'react-router';
import { useEffect, useState } from 'react';
import { Button, Grid, Paper } from '@mui/material';
import { Table } from '@components/Table/Table';
import { Select } from '@components/Select';
import {
  useNotificationsControllerSendNewVacancyMutation,
  VacancyResponse,
  VacancySearchRequest,
} from '@api/admin/adminGeneratedApi';
import { Icon } from '@components/Icon';
import { Option } from '@components/Select/types';
import { useFilterVacancy } from '@area/vacancies/components/VacanciesTable/hooks/useFilterVacancy';
import { VacanciesFilter } from '@area/vacancies/components/VacanciesTable/VacanciesFilter';
import { useQueryParams } from '@hooks/useQueryParams';
import { getColumns } from './columns';
import styles from './styles.module.scss';
import { VacancyFilterFormValues } from './types/filter.type';

export const vacanciesFilterOptions = [
  { label: 'Статус в Кампусе', value: 'campusStatus' },
  { label: 'Количество откликов > 0', value: 'responsesCount' },
  { label: 'Статус в HRoom', value: 'hroomStatus' },
  { label: 'Город', value: 'city' },
  { label: 'Компания', value: 'company' },
  { label: 'Требуемые университеты', value: 'universities' },
  { label: 'Требуемые специальности', value: 'specialties' },
  { label: 'Требуемые формы обучения', value: 'studyForms' },
  { label: 'Требуемые статус обучения', value: 'studyStatus' },
];

export const VacanciesTable = () => {
  const navigate = useNavigate();
  const outlet = useOutlet();
  const hasMore: boolean = false;
  const { params } = useQueryParams();
  const [filter, setFilter] = useState<string[]>(Object.keys(params));

  const { filterVacancies, data: vacancies, isLoading } = useFilterVacancy();
  const [sendNewVacancy, { isLoading: isSending }] = useNotificationsControllerSendNewVacancyMutation();

  const columns = getColumns();

  const onRowClick = ({ id }: VacancyResponse) => {
    return id ? navigate(id) : null;
  };

  const [selectedFilter, setSelectedFilter] = useState<Option | Option[]>(
    vacanciesFilterOptions.filter((el) => filter.includes(el.value)),
  );

  const onChangeSelectFilter = (values: Option | Option[]) => {
    setSelectedFilter(values);
    const filterKeys = Array.isArray(values) ? values.map((el) => el.value) : [];
    setFilter(filterKeys);
  };

  const onChange = (values: VacancyFilterFormValues) => {
    const val: VacancySearchRequest = {
      isKampusPublished: values.campusStatus?.value ? values.campusStatus?.value === 'published' : undefined,
      // responsesCount: Option<'gt0' | 'eq0'>; // Пока нет
      hroomStatus: values.hroomStatus?.value,
      city: values.city,
      company_name: values.company,
      universities_ids: values.universities?.value ? [values.universities?.value] : undefined,
      specialties_ids: values.specialties?.value ? [values.specialties?.value] : undefined,
      education_form_ids: values.studyForms?.value ? [values.studyForms?.value] : undefined,
      academic_status_ids: values.studyStatus?.value ? [values.studyStatus?.value] : undefined,
    };

    filterVacancies({
      vacancySearchRequest: val,
      skip: 0,
      size: 50,
      asc: false,
    });
  };
  const hiddenFilterButtons = (
    <>
      <Select
        placeholder="Добавить/Снять фильтр"
        icon={<Icon name="filterAdd" />}
        options={vacanciesFilterOptions}
        onChange={onChangeSelectFilter}
        value={selectedFilter}
        multiple
        isMenuSelect
      />
    </>
  );

  useEffect(() => {
    if (!outlet) {
      filterVacancies({
        vacancySearchRequest: {
          isKampusPublished: params.campusStatus ? params.campusStatus === 'published' : undefined,
          // responsesCount: Option<'gt0' | 'eq0'>; // Пока нет
          hroomStatus: params.hroomStatus,
          city: params.city,
          company_name: params.company,
          universities_ids: params.universities ? [params.universities] : undefined,
          specialties_ids: params.specialties ? [params.specialties] : undefined,
          education_form_ids: params.studyForms ? [params.studyForms] : undefined,
          academic_status_ids: params.studyStatus ? [params.studyStatus] : undefined,
        },
        skip: 0,
        size: 50,
        asc: false,
      });
    }
  }, [outlet]);

  return (
    <>
      <Grid textAlign={'right'}>
        <Button
          onClick={() => sendNewVacancy()}
          variant="outlined"
          startIcon={<Icon name="email" />}
          disabled={isSending}>
          Отправить email-ы
        </Button>
      </Grid>
      <Grid>
        <VacanciesFilter onChange={onChange} filter={filter} hiddenFilterButtons={hiddenFilterButtons} />
      </Grid>
      <Grid item sx={{ width: '100%' }}>
        <Paper className={styles.paper}>
          <Table<VacancyResponse>
            columns={columns}
            data={vacancies?.data || []}
            // fetched={isFetched}
            loading={isLoading}
            onRowClick={onRowClick}
          />
          {hasMore && (
            <Button
              variant="outlined"
              className={styles.loadMoreBtn}
              disabled={isLoading}
              startIcon={<Icon name="more" />}
              // onClick={() => fetchVacancies()}
            >
              Загрузить еще
            </Button>
          )}
        </Paper>
      </Grid>
    </>
  );
};
